import { Component, OnInit, Input } from '@angular/core';
import { QuoteSummary } from '../models/quote-summary';
import { ActivatedRoute } from '@angular/router';
import { CoreApiService } from '../services/core-api.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WarningModalComponent } from './warning-modal/warning-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { oeresult } from '../models/oeresult';
import { SelectedPlan } from '../models/selected-plan';
import { SnackBarComponent } from '../components/snackbar/snackbar.component';


@Component({
    selector: 'app-enrollment-button',
    templateUrl: './enrollment-button.component.html',
    styleUrls: ['./enrollment-button.component.scss']
})
export class EnrollmentButtonComponent implements OnInit {
    public cookieValue: string;
    @Input() selectedPlans: Object;
    @Input() allPlansByLoc: Object;
    public quoteSummary: QuoteSummary;
    public quoteid: string;
    public enrollmentId: string;
    public benAdmin: string;
    public enrollmentmethod: string;
    public oeResult: oeresult;
    public isLoading = false;
    public isDisabled = true;
    public redirectToAwsUrl: string;
    public awsRedirectUrl: string;
    loc = [];
    locWithPlans = [];

    constructor(
        private api: CoreApiService,
        private route: ActivatedRoute,
        public dialog: MatDialog,
        private cookieService: CookieService,
        private toast: MatSnackBar
    ) {}
    openSnackBar() {
        this.isLoading = false;
        this.toast.openFromComponent(SnackBarComponent, {
            duration: 4000,
            horizontalPosition: 'left',
            verticalPosition: 'bottom'
        });
        if (!this.isLoading) {
            this.dialog.closeAll();
        }
    }
    ngOnInit() {
        this.quoteid = this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']);
        this.enrollmentId = this.api.decryptedEnrollmentId(this.route.snapshot.params['enrollmentId']);
        this.cookieValue = this.cookieService.get('canvasUrl'); // To Get Cookie value
        this.api
            .getQuoteSummary(
                this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']),
                this.api.decryptedEnrollmentId(this.route.snapshot.params['enrollmentId'])
            )
            .subscribe(qs => {
                this.quoteSummary = qs;
            });
    }    

    get hasSelectedPlans(): boolean {
        if (this.selectedPlans) {
            for (const key in this.selectedPlans) {
                if (this.selectedPlans.hasOwnProperty(key)) {
                    const value = this.selectedPlans[key];
                    if (value.length > 0) {
                        this.isDisabled = false;
                        return true;
                    }
                }
            }
        }
        this.isDisabled = true;
        return false;
    }
    
    confirmEnrollment(): void {

        // Checks for lines of coverage that have no selected plans.
        // If the line of coverage has no selections, it's added to an array.       
        this.getPlans();
        for (const key in this.selectedPlans) {
            if (this.selectedPlans.hasOwnProperty(key)) {
                const value = this.selectedPlans[key];
                if (value.length === 0) {
                    if (this.locWithPlans.indexOf(key) > -1) {
                        if (key === 'Voluntary') {
                            this.loc.push('Critical Illness, Accident, Hospital Indemnity');
                            continue;
                        }
                        else if (key === 'LegalServices') {
                            this.loc.push('Legal Services');
                            continue;
                        }
                        else if (key === 'IdentityProtection') {
                            this.loc.push('Identity Protection');
                            continue;
                        }
                        this.loc.push(key);
                    }
                    else {
                        continue;
                    }
                }
            }
        }
        // Call the sendSelections method to persist any plans that were selected without saving them first
        this.sendSelections();
        // If the Array is empty, call the send enrollment method.
        // Otherwise, call the warning dialog method.
        if (this.loc.length === 0) {
            this.isLoading = true;
            this.submitEnrollment();
        } else {
            this.scrollToCenter();
            this.openWarningDialog();
        }
    }

    openWarningDialog() {
        const dialogRef = this.dialog.open(WarningModalComponent, {
            width: '580px', height: "300px",
            disableClose: true,
            data: { parentComponent: this }
        });
        dialogRef.afterClosed().subscribe(() => {
            this.loc = [];
        });
    }

    // This script will scroll the page to the position where the modal is open.
    scrollToCenter() {
        const win: any = window;
        const sizes = win.Sfdc.canvas.client.size();
        const offSet = 200;
        const top = (sizes.heights.contentHeight / 2) - offSet;
        const args = JSON.stringify({ oeScrollToTop: true, top: top });
        return this.getCanvasToken().then((token: any) => {
            window.top.postMessage(args, token.client.targetOrigin);
        });
    }

    isCanvas() {
        const isInCanvas = window !== window.top;
        return isInCanvas;
    }

    private parseCanvasToken(signedRequest) {
        const win:any= window;
        const part = signedRequest.split('.')[1];
        const decodedToken = win.Sfdc.canvas.decode(part);
        const canvasToken = JSON.parse(decodedToken);
        return canvasToken;
    }

    private getCanvasToken() {
        const win: any = window;
        return new Promise((resolve, reject) => {
            win.Sfdc.canvas.client.refreshSignedRequest((data: any) => {
                if (data.status === 200) {
                    const signedRequest = data.payload.response;
                    const token = this.parseCanvasToken(signedRequest);
                    resolve(token);
                } else {
                    reject(new Error('Error occurred while getting canvas token'));
                }
            });
        });
    }
    
    //set PC Complete
    private setPlanConfirmationComplete() {
        this.api
            .setPlanSelectionComplete(
                this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']),
                this.api.decryptedEnrollmentId(this.route.snapshot.params['enrollmentId']),
                'nobody'
            )
            .subscribe(res => { });
    }

    submitEnrollment() {
        this.setPlanConfirmationComplete();
        this.raiseRedirectEventToAWS(false);
    }

    raiseRedirectEventToAWS(isCancel) {
        this.getCanvasToken().then((token: any) => {
            var enrollmentUrl, args, intUrl;
            var decryptedEnrollmentId = this.api.decryptedEnrollmentId(token.context.environment.parameters.enrollmentId);
            //Broker login flow via AWS or ASD Users
            if (token.context.user.userType.toUpperCase().trim() === "POWER_CUSTOMER_SUCCESS" || token.context.environment.parameters.isASDUser.toUpperCase().trim() === "TRUE") {
                if (isCancel === true) {                    
                    enrollmentUrl = token.client.targetOrigin + "/s/enrollment/" +
                        decryptedEnrollmentId;
                } else {
                    enrollmentUrl = token.client.targetOrigin +
                        "/s/startenrollment?stage=Client+Details&enId=" +
                        decryptedEnrollmentId + "&redirected=true";
                }
                args = JSON.stringify({
                    appendRedirectLocation: false,
                    oeRedirectUrl: enrollmentUrl
                });
                console.log("Raised Redirect to AWS - Broker Login");
                window.top.postMessage(args, token.client.targetOrigin);
                
            }
           
            else {
                //This is the internal SalesForce User Flow and the redirect url should also be provided by AWS.
                intUrl = "https://" + token.context.environment.locationUrl.split("/")[2];
                enrollmentUrl = intUrl +
                    "/lightning/cmp/c__AFocus_Resume_Enrollment?c__recordId=" +
                    decryptedEnrollmentId + "&isShowWizard=false";
                if (isCancel === true) {
                    enrollmentUrl = enrollmentUrl + "&cancelled=true";
                }
                //Internal user
                args = JSON.stringify({
                    appendRedirectLocation: false,
                    enrollmentId: decryptedEnrollmentId,
                    oeRedirectUrl: enrollmentUrl

                });
                

                //Raise message
                //intUrl is the parent URL for the internal user login
                console.log("Redirect Event Argument for Internal User {0}", args);
                console.log("Raised Redirect to AWS - Internal User login, Token received {0}", token);
                window.top.postMessage(args, intUrl);
               
            }
        });
    }

    sendSelections() {
        const data = [];
        for (const loc in this.selectedPlans) {
            if (this.selectedPlans.hasOwnProperty(loc)) {
                this.selectedPlans[loc].map(p =>
                    data.push(new SelectedPlan(p))
                );
            }
        }
        this.api
            .savePlanSelections(
                this.api.decryptedQuoteId(this.route.snapshot.params['quoteId']),
                this.api.decryptedEnrollmentId(this.route.snapshot.params['enrollmentId']),
                'nobody',
                data
            )
            .subscribe(res => {});
    }
    isEmpty(value) {
        return (value == null || value.length === 0);
    }

    cancelEnrollment() {
      this.raiseRedirectEventToAWS(true);
    }

    getPlans() {

        let allPlans = this.allPlansByLoc;
        for (var loc in allPlans) {
            if (allPlans.hasOwnProperty(loc)) {
                if (this.locWithPlans.indexOf(loc) > -1) {
                    continue;
                }
                else {
                    var plans = allPlans[loc].selectedPlanSummaries
                    if (plans !== null) {
                        if (loc === 'HospitalIndemnity' || loc === 'Accident' || loc === 'CriticalIllness') {
                            loc = 'Voluntary';
                        }
                        if (this.locWithPlans.indexOf(loc) > -1) {
                            continue;
                        }
                        this.locWithPlans.push(loc);
                    }
                }
            }
        }
    }

}
